export const fixGradientTextForScreenshot = (clonedDoc: Document) => {
    const allElements = Array.from(
        clonedDoc.querySelectorAll('*')
    ) as HTMLElement[];

    allElements.forEach((el) => {
        const style = window.getComputedStyle(el);
        const bgImage = style.backgroundImage || '';
    
        const hasGradient = bgImage.includes('linear-gradient');
        const clipText =
            style.webkitBackgroundClip === 'text' ||
            style.backgroundClip === 'text';
    
        if (!hasGradient || !clipText) return;
    
        const colors = bgImage.match(
            /(rgb|rgba)\([^)]+\)|#[a-fA-F0-9]{3,6}/g
        );
        if (!colors || colors.length < 2) return;
    
        Array.from(el.childNodes).forEach((node) => {
            if (
                node.nodeType === Node.TEXT_NODE &&
                node.textContent?.trim()
            ) {
                const textContent = node.textContent.trim();
                const gradId =
                    'grad_' + Math.random().toString(36).substring(2, 9);
            
                const rect = el.getBoundingClientRect();
                const originalWidth = rect.width;
                const originalHeight = rect.height;
            
                if (!originalWidth) return;
            
                const maxWidth = originalWidth * 1.05;
            
                const measureSpan = document.createElement('span');
                measureSpan.style.cssText = `
                    font-size: ${style.fontSize};
                    font-family: ${style.fontFamily};
                    font-weight: ${style.fontWeight};
                    letter-spacing: ${style.letterSpacing};
                    white-space: nowrap;
                    visibility: hidden;
                    position: absolute;
                `;
                document.body.appendChild(measureSpan);
            
                const words = textContent.split(' ');
                const lines: string[] = [];
                let currentLine = '';
            
                words.forEach((word) => {
                    const testLine = currentLine
                        ? currentLine + ' ' + word
                        : word;
                
                    measureSpan.textContent = testLine;
                    const testWidth =
                        measureSpan.getBoundingClientRect().width;
                
                    if (testWidth > maxWidth && currentLine) {
                        lines.push(currentLine);
                        currentLine = word;
                    } else {
                        currentLine = testLine;
                    }
                });
            
                if (currentLine) {
                    lines.push(currentLine);
                }
            
                document.body.removeChild(measureSpan);
            
                const computedLineHeight = parseFloat(style.lineHeight);
                const fontSize = parseFloat(style.fontSize);
            
                const lineHeight =
                    !isNaN(computedLineHeight)
                        ? computedLineHeight
                        : fontSize * 1.2;
            
                const calculatedHeight = lineHeight * lines.length;
                const finalHeight = Math.ceil(
                    Math.max(originalHeight, calculatedHeight)
                );
            
                const svgNS = 'http://www.w3.org/2000/svg';
                const svg = document.createElementNS(svgNS, 'svg');
            
                svg.setAttribute('width', maxWidth.toString());
                svg.setAttribute('height', finalHeight.toString());
                svg.setAttribute(
                    'viewBox',
                    `0 0 ${maxWidth} ${finalHeight}`
                );
            
                svg.style.display = 'inline-block';
                svg.style.verticalAlign = 'top';
                svg.style.overflow = 'visible';
            
                svg.innerHTML = `
                    <defs>
                        <linearGradient id="${gradId}" x1="0%" y1="0%" x2="100%" y2="0%">
                            ${colors
                                .map(
                                    (c, i) =>
                                        `<stop offset="${
                                            (i / (colors.length - 1)) * 100
                                        }%" stop-color="${c}" />`
                                )
                                .join('')}
                        </linearGradient>
                    </defs>
                    <text
                        x="0"
                        y="${lineHeight}"
                        fill="url(#${gradId})"
                        font-family="${style.fontFamily.replace(/"/g, "'")}"
                        font-size="${style.fontSize}"
                        font-weight="${style.fontWeight}"
                    >
                        ${lines
                            .map(
                                (line, i) =>
                                    `<tspan x="0" dy="${
                                        i === 0 ? 0 : lineHeight
                                    }">${line}</tspan>`
                            )
                            .join('')}
                    </text>
                `;
                        
                el.replaceChild(svg, node);
            }
        });
    
        el.style.setProperty('background', 'none', 'important');
        el.style.setProperty('background-image', 'none', 'important');
        el.style.setProperty(
            '-webkit-text-fill-color',
            'transparent',
            'important'
        );
    });
}